export enum LockdropStatus {
  Upcoming = "Upcoming",
  Live = "Live",
  Allocation = "Allocation",
  Ended = "Ended",
}
